export default __webpack_public_path__ + "static/media/redux-observable.c3e2813f.svg";